import { apiClient } from './apiClient';
import {
  CoffeeChatAnswerData,
  CoffeeChatAnswerListResponse,
  CoffeeChatAnswerResponse,
  CreateAnswerRequest,
  UpdateAnswerRequest,
  UploadAttachmentsResponse,
  CoffeeChatAnswerFilterState,
  CoffeeChatAnswerPaginationState,
  ApiResponse
} from '../../types/admin';

export type {
  CoffeeChatAnswerData,
  CoffeeChatAnswerListResponse,
  CoffeeChatAnswerResponse,
  CreateAnswerRequest,
  UpdateAnswerRequest,
  UploadAttachmentsResponse,
  CoffeeChatAnswerFilterState,
  CoffeeChatAnswerPaginationState,
  ApiResponse
};

export const adminCoffeeChatAnswerApi = {
  getAnswers: async (
    filter: CoffeeChatAnswerFilterState,
    pagination: { page: number; size: number }
  ): Promise<CoffeeChatAnswerListResponse> => {
    const params: Record<string, any> = {
      page: pagination.page,
      size: pagination.size,
    };
    if (filter.visible !== null) params.visible = filter.visible;
    if (filter.mentorId !== null) params.mentorId = filter.mentorId;
    if (filter.isAnswered !== null) params.isAnswered = filter.isAnswered;
    if (filter.fromDate?.trim()) params.from = filter.fromDate;
    if (filter.toDate?.trim()) params.to = filter.toDate;

    const response = await apiClient.get('/api/admin/coffee-chats/list', { params });
    return response.data;
  },

  createAnswer: async (postId: number, request: CreateAnswerRequest): Promise<CoffeeChatAnswerResponse> => {
    const response = await apiClient.post(`/api/admin/coffee-chats/${postId}/answer`, request);
    return response.data;
  },

  updateAnswer: async (postId: number, replyId: number, request: UpdateAnswerRequest): Promise<CoffeeChatAnswerResponse> => {
    const response = await apiClient.put(`/api/admin/coffee-chats/${postId}/answer/${replyId}`, request);
    return response.data;
  },

  deleteAnswer: async (postId: number, replyId: number): Promise<void> => {
    await apiClient.delete(`/api/admin/coffee-chats/${postId}/answer/${replyId}`);
  },

  uploadAttachments: async (images: File[]): Promise<UploadAttachmentsResponse> => {
    const formData = new FormData();
    images.forEach(image => formData.append('images', image));
    const response = await apiClient.post('/api/reply/attachments', formData);
    return response.data;
  },

  deleteAttachments: async (replyId: number, imageUrls: string[]): Promise<ApiResponse<any>> => {
    const formData = new FormData();
    imageUrls.forEach(url => formData.append('imageUrls', url));
    const response = await apiClient.delete(`/api/reply/${replyId}/attachments`, { data: formData });
    return response.data;
  },

  toggleAnswerExposure: async (replyId: number, exposed: boolean): Promise<CoffeeChatAnswerResponse> => {
    const response = await apiClient.patch(`/api/admin/replies/${replyId}/exposed?exposed=${exposed}`);
    return response.data;
  },
};
